import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { createUserContractAsync, updateUserContractAsync, getUserContractByIdAsync, getUserContractsByFreelancerAsync, getMyUserContractsAsync } from './userContractThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const userContractSlice = createSlice({
    name: 'userContract',
    initialState,
    reducers: {
        clearCurrentUserContract: (state) => {
            state.currentUserContract = undefined;
            state.currentUserContractId = undefined;
            state.currentUserContractRequestId = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createUserContractAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createUserContractAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(createUserContractAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateUserContractAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateUserContractAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(updateUserContractAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getUserContractByIdAsync.pending, (state, action) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
            state.currentUserContract = undefined;
            state.currentUserContractId = action.meta.arg;
            state.currentUserContractRequestId = action.meta.requestId;
        })
            .addCase(getUserContractByIdAsync.fulfilled, (state, action) => {
            if (state.currentUserContractRequestId !== action.meta.requestId ||
                state.currentUserContractId !== action.meta.arg) {
                return;
            }
            state.status = APIStatus.IDLE;
            state.currentUserContract = action.payload;
        })
            .addCase(getUserContractByIdAsync.rejected, (state, action) => {
            if (state.currentUserContractRequestId !== action.meta.requestId ||
                state.currentUserContractId !== action.meta.arg) {
                return;
            }
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getUserContractsByFreelancerAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getUserContractsByFreelancerAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.userContracts = action.payload;
        })
            .addCase(getUserContractsByFreelancerAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getMyUserContractsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getMyUserContractsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.userContracts = action.payload;
        })
            .addCase(getMyUserContractsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { clearCurrentUserContract } = userContractSlice.actions;
export default userContractSlice.reducer;
